<template>
  <div class="d-flex justify-content-center">
    <div class="spinner-border" role="status"></div>
  </div>
</template>

<script>
export default {
  name: "SpinnerComp",
};
</script>
